import React, { useState } from 'react';
import { SolutionProvider } from './context/SolutionContext';
import Header from './components/layout/Header';
import Sidebar from './components/layout/Sidebar';
import MainPanel from './components/layout/MainPanel';
import Toast from './components/ui/Toast';

const Aisolarch = () => {
  const [activeView, setActiveView] = useState('auto');
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  
  return (
    <SolutionProvider>
      <div className="h-screen w-screen flex flex-col overflow-hidden bg-gray-100">
        <Header />
        <div className="flex-1 flex overflow-hidden">
          <Sidebar 
            activeView={activeView}
            setActiveView={setActiveView}
            isCollapsed={isSidebarCollapsed}
            setIsCollapsed={setIsSidebarCollapsed}
          />
          <MainPanel 
            activeView={activeView}
            setActiveView={setActiveView}
          />
        </div>
        <Toast />
      </div>
    </SolutionProvider>
  );
};

export default Aisolarch;